module.exports = __webpack_public_path__ + "static/media/Events-03.1f2d6603.webp";